const borders = {
  radii: {
    none: '0',
    sm: '4px',
    half: '0.5rem',
    base: '1rem',
    md: '12px',
    lg: '16px',
    xl: '24px',
    full: '9999px',
  },
};

export default borders;
